// Code generated by balancegen from data/contracts/mobile.toml. DO NOT EDIT.
// Regenerate with scripts/gen-data.sh.
//
// The store apps (mobile-apps.md §11, R2929). Compile-time lane (R310):
// a change needs the regeneration and a new build of each consumer.

/** The app id of both store apps (mobile-apps.md §11). */
export const STORE_APP_ID = 'io.aquaphobia.app';

/** The iOS URL scheme of the sign-in return: the app id (mobile-apps.md §6). */
export const STORE_APP_URL_SCHEME = 'io.aquaphobia.app';

/** The paths that open in a store app: the Universal Links and the App Links. */
export const STORE_APP_LINK_PATHS: readonly string[] = ['/arcade', '/replay'];

/** The query of the TWA start URL (mobile-apps.md §4). */
export const ANDROID_START_QUERY = 'shell=android';

/** The key of the start URL query. */
export const ANDROID_START_PARAM = 'shell';

/** The value of the start URL query. */
export const ANDROID_START_VALUE = 'android';

/** The document.referrer of a page that the TWA opened (mobile-apps.md §4). */
export const ANDROID_REFERRER = 'android-app://io.aquaphobia.app';

/** The bridge version of this build (mobile-apps.md §5). */
export const SHELL_BRIDGE_VERSION = 1;

/** The global object that the iOS app shell injects. */
export const SHELL_GLOBAL = 'apShell';

/** The WKWebView message handler that receives an op. */
export const SHELL_HANDLER = 'ap';

/** The CustomEvent that carries an answer of the app shell. */
export const SHELL_EVENT = 'ap-shell';

/** The user agent token of the iOS app shell, before `/<bridge>`. */
export const SHELL_USER_AGENT = 'ApShell/ios';

/** The first bridge version that knows each op (mobile-apps.md §5). */
export const SHELL_OPS = {
  /** ask for the push permission and answer the APNs token, or push.denied. */
  'push.register': 1,
  /** answer the push permission and the APNs token without a prompt. */
  'push.state': 1,
  /** play a vibration pattern through Core Haptics. */
  'buzz': 1,
  /** run the OAuth flow in ASWebAuthenticationSession, then load the handoff URL. */
  'signin': 1,
  /** open an off-origin URL in Safari. */
  'open': 1,
} as const;

/** One op of the bridge. */
export type ShellOp = keyof typeof SHELL_OPS;
